<template>
  <div>
    <section class="das-form-container das-form-group">
      <el-row :gutter="16" class="dialog-search-bar">
        <el-col :span="10">
          <div class="das-form-input">
            <div class="label required">Trường tìm kiếm</div>
            <validation-provider :name="$t('field.status')" rules="required">
              <el-select v-model="searchParams.type">
                <el-option label="Tên" value="name"></el-option>
                <el-option
                  label="Số điện thoại"
                  value="phoneNumber"
                ></el-option>
                <el-option label="Địa chỉ e-mail" value="email"></el-option>
                <el-option
                  label="Số căn cước/Visa"
                  value="idCardOrVisa"
                ></el-option>
              </el-select>
            </validation-provider>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="das-form-input">
            <div class="label">
              {{ 'Từ khóa' }}
            </div>
            <div class="child-w-80">
              <input
                v-model="searchParams.keyword"
                type="text"
                @keydown="search(this)"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="4" class="dialog-search-bar__btn">
          <button class="btn primary small outline" @click="getTableData">
            Tìm kiếm
          </button>
        </el-col>
      </el-row>
    </section>
    <GridVx
      ref="CustomerTable"
      class=""
      :columns="customersTableColumns"
      :rows="customersTableData"
      :auto-select-first-row="false"
      :auto-size-cell="true"
      @rowClicked="onRowSelected"
    ></GridVx>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
  </div>
</template>
<script>
import { getTravellers } from '@/api/traveller'
import GridVx from '@/components/grid/GridVx.vue'
import paginationMixin from '@/mixins/paginationMixin'
export default {
  components: { GridVx },
  mixins: [paginationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customerRecord: null,
      searchParams: {
        type: 'name',
        keyword: ''
      },
      selectedCustomer: null,
      customersTableColumns: [
        { headerName: 'STT', field: 'no' },
        { headerName: 'Mã khách hàng', field: 'id' },
        { headerName: 'Họ', field: 'last_name' },
        { headerName: 'Tên', field: 'first_name' },
        { headerName: 'Ngày sinh', field: 'birth' },
        {
          headerName: 'Giới tính',
          field: 'sex',
          valueFormatter(params) {
            switch (params.value) {
              case 1:
                return 'Nam'
              case 2:
                return 'Nữ'
              default:
                return 'Không xác định'
            }
          }
        },
        { headerName: 'Số điện thoại', field: 'phone_number' },
        { headerName: 'Email', field: 'email' },
        { headerName: 'Địa chỉ 1', field: 'address_1' },
        { headerName: 'Căn cước', field: 'id_card' },
        { headerName: 'Quốc tịch', field: 'nationality' }
      ],
      customersTableData: []
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getTableData()
      }
    }
  },
  async mounted() {
    await this.getTableData()
  },
  methods: {
    onCreateCustomer() {},
    onRowSelected(customers) {
      this.$emit('onCustomerChecked', customers[0])
    },
    async onPageSizeChange(value) {
      this.pageParams.pageSize = value
      this.pageParams.pageNum = 1
      await this.getTableData()
    },
    async onPageChanged(value) {
      this.pageParams.pageNum = value
      await this.getTableData(value)
    },
    async getTableData() {
      const query = {}
      if (this.searchParams.keyword != null) {
        query[this.searchParams.type] = this.searchParams.keyword
      }
      await getTravellers(query, {
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum
      }).then(response => {
        this.customersTableData = response.data
        this.pageParams.totalPage = Math.ceil(
          response.total / response.page_size
        )
        this.pageParams.pageNum = response.page_num
      })
    },
    close() {
      this.$emit('close')
    },
    search(ele) {
      if (event.key === 'Enter') {
        this.getTableData()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-customer-table {
  margin-bottom: 24px;
}

.dialog-search-bar {
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
}

.dialog-search-bar__btn {
  margin-top: auto;
}
</style>
